module.exports = __webpack_public_path__ + "static/media/roboto-medium-webfont.b3859b24.ttf";